import React from "react";
import { useSelector } from "react-redux";
import StudentPerformanceCard from "./StudentPerformanceCard";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";

const StudentPerformanceData = () => {
  const { results, loading } = useSelector((state) => state.studentPerformance);


  const lessonCount = results?.[0]?.days?.length || 8;


  const getOrdinalSuffix = (num) => {
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;

    // 10, 20, 30...
    if ([10, 20, 30, 40, 50, 60, 70, 80, 90].includes(lastTwoDigits)) {
      return "cu";
    }

    switch (lastDigit) {
      case 1:
      case 2:
      case 5:
      case 7:
      case 8:
        return "ci";
      case 3:
      case 4:
      case 11:
      case 12:
        return "cü";
      case 6:
        return "cı";
      case 9:
      case 10:
        return "cu";
      default:
        return "ci";
    }
  };

  return (
    <table className="details-table teacher-table">
      <thead>
        <tr>
          <th></th>
          {Array.from({ length: lessonCount }, (_, i) => (
            <th key={i}>
              {i + 1}-{getOrdinalSuffix(i + 1)} dərs
            </th>
          ))}
          <th>Ayların Ortalama Yekun Nəticəsi</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr>
            <td colSpan={lessonCount + 3}>
              <SmallLoading />
            </td>
          </tr>
        ) : (
          results
            ?.slice()
            .reverse()
            .map((monthData, index) => (
              <StudentPerformanceCard
                key={monthData?._id}
                monthData={monthData}
              />
            ))
        )}
      </tbody>
    </table>
  );
};

export default StudentPerformanceData;
